<template>
  <div>
    <!-- enter or regster -->
    <OpaSlideModal 
      title="Selecione um meio para continuar" 
      direction="up" 
      v-model="enterOrRegister"
      @slideModalClose="() => enterOrRegister = false"
      >
        <!--b-row class="mt-4">
          <b-col class="text-center">
            Logar com google
          </b-col>
        </b-row>
        <b-row>
          <b-col style="display:inline-block">
            Logar com facebook
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            ou
          </b-col>
        </b-row -->
        <b-row class="mt-4">
          <b-col class="text-center">
            <button class="solid" @click="addressOrRegister()" :style="{backgroundColor: getCssColor('primary_bt')}">Cadastre-se</button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center mt-4">
            <button class="wire" @click="loginModal=!loginModal" :style="{color: getCssColor('primary_bt'), borderColor: getCssColor('primary_bt')}">Já tenho Cadastro!</button>
          </b-col>
        </b-row>
    </OpaSlideModal>

    <!-- login -->
    <OpaSlideModal 
      title="Login" 
      direction="left" 
      v-model="loginModal"
      @slideModalClose="() => loginModal = false"
      >
        <b-row>
          <b-col>
            <LoginForm2 
              @forgotenClick="forgot" 
              @loggedIn="() => {doLogin();$store.state.showLoading = false}"
              @openValidation="() => {openValidation()}" />
          </b-col>
        </b-row>
    </OpaSlideModal>

    <!-- register -->
    <OpaSlideModal 
      title="Cadastre-se" 
      direction="left" 
      v-model="registerModal"
      @slideModalClose="() => registerModal = false"
      >
        <b-row >
          <b-col class="pb-4" style="height:calc(100vh - 100px);overflow:auto;">
            <RegisterForm2 @openValidation="() => { openValidation() }" />
          </b-col>
        </b-row>
    </OpaSlideModal>

    <!-- validation -->
    <OpaSlideModal 
      title="Código de Validação" 
      direction="left" 
      v-model="validationModal"
      @slideModalClose="() => validationModal = false"
      >
        <b-row >
          <b-col class="pb-4" style="height:calc(100vh - 100px);overflow:auto;">
            <b-row>
              <b-col class="mt-4 text-center">
                Insira o código de validação enviado pelo SMS/E-Mail
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-3">
                <OpaInputText type="number" name="code" placeholder="Código de Validação" v-model="code" :required="true" :icon="['fal', 'user-lock']"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-4 text-center">
                <button class="solid" @click="doValidation()" :style="{backgroundColor: getCssColor('primary_bt')}">
                    CONTINUAR
                </button>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-4 text-center">
                <button class="wire" @click="reSendValidationCode()" :style="{color: getCssColor('primary_bt')}">
                    Reenviar Código de Validação
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
    </OpaSlideModal>

    <!-- forgot -->
    <OpaSlideModal 
      title="Esqueci minha senha" 
      direction="right" 
      v-model="forgotModal"
      @slideModalClose="() => forgotModal = false"
      >
        <b-row >
          <b-col class="mt-4">
            <OpaInputText type="text" v-model="forgotEmail" placeholder="E-Mail" :required="true" :icon="['fal', 'envelope']"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-4 text-center">
            <button class="solid" @click="resendCodeToForgot()" :style="{backgroundColor: getCssColor('primary_bt')}">
                CONTINUAR
            </button>
          </b-col>
        </b-row>
    </OpaSlideModal>

    <!-- change pass -->
    <OpaSlideModal 
      title="Alterar Senha" 
      direction="right" 
      v-model="changePassModal"
      @slideModalClose="() => changePassModal = false"
      >
        <b-row >
          <b-col class="mt-4">
            <OpaInputText type="password" v-model="newPassword" placeholder="Nova Senha" :required="true" :icon="['fal', 'key']"/>
          </b-col>
        </b-row>
        <b-row >
          <b-col class="mt-2">
            <OpaInputText type="password" v-model="newPasswordConfirm" placeholder="Confirme Nova Senha" :required="true" :icon="['fal', 'key']"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-4 text-center">
            <button class="solid" @click="changePass()" :style="{backgroundColor: getCssColor('primary_bt')}">
                CONTINUAR
            </button>
          </b-col>
        </b-row>
    </OpaSlideModal>


  </div>
</template>

<script>

import colors from '@/mixins/colors'
import OpaSlideModal from '@/components/OpaSlideModal'
import OpaInputText from '@/components/OpaInputText'
import { EventBus } from '@/behaviours/event-bus'
import LoginForm2 from '@/components/LoginForm2'
import RegisterForm2 from '@/components/RegisterForm2'
import UserConn from '@/connection/user'

export default {

  props: ['value', 'addressRequiredForRegister'],

  components: {OpaInputText, OpaSlideModal, LoginForm2, RegisterForm2},

  data () {
    return {
      enterOrRegister: false,
      loginModal: false,
      registerModal: false,
      forgotModal: false,
      validationModal: false,
      changePassModal: false,
      // forgot and change pass
      forgotEmail: null,
      validationToForgot: false,
      newPassword: null,
      newPasswordConfirm: null,
      // validation code
      code: null
    }
  },

  mixins: [colors],

  mounted () {
    EventBus.$on('continueWithRegistration', () => {
      this.registerModal = true
    }) 
  },

  destroyed() {
    EventBus.$off('continueWithRegistration')
  },

  watch: {
    value (v) {
      this.enterOrRegister = v
    },

    enterOrRegister (v) {
      this.$emit('slideModalChange', v)
    },

  },

  methods: {
    doLogin () {
      console.log('DO LOGIN EMITED')
      this.$emit('loginRegisterLogged')
      this.loginModal = false
      this.enterOrRegister = false
    },

    openValidation () {
      this.validationModal = true
      this.enterOrRegister = false
      this.registerModal = false
      this.validationToForgot = false
    },

    forgot () {
      console.log('forgot forgot forgot')
      this.forgotModal = true
    },

    addressOrRegister () {
      //registerModal=!registerModal
      if ((!this.$store.state.tempAddress.street || !this.$store.state.tempAddress.number) && this.addressRequiredForRegister) {
        /// emit w8 register to address component
        this.$emit('requestAddressToRegister')
        this.loginModal = false
        this.enterOrRegister = false
      } else {
        this.registerModal=!this.registerModal
      }
    },

    

    // TODO VALIDATION IN MODAL
    async doValidation() {

      if (this.code && this.code.length === 4) {
        this.$store.state.showLoading = true
        this.$store.state.tempCode = this.code
        let result = await UserConn.verifyRegister(this.code)
        if (!result.error) {

          // if this validation is not to forgot
          if(!this.validationToForgot) {
            //auto login
            let userTemp = localStorage.getItem('tempMail')
            let passTemp = localStorage.getItem('tempPass')
            if (userTemp && passTemp) {
              let result2 = await UserConn.doLogin(userTemp, passTemp)
              if (result2.error) {
                this.$store.state.showLoading = false
                EventBus.$emit('showAlert', 'error', 'Usuário e/ou senha inválidos')
              } else {
                localStorage.setItem('tempMail', null)
                localStorage.setItem('tempPass', null)
                if (this.$store.state.registerLoginOrigin === 'cart'){
                  this.$router.push({path: '/cart'})
                } else if (this.$store.state.registerLoginOrigin === 'history'){
                  this.$router.push({path: '/history'})
                } else {
                  console.log('registers variables ', this.addressRequiredForRegister,  this.$store.state.user.adresses.length)
                  if (this.addressRequiredForRegister && !this.$store.state.user.adresses.length) {
                    this.$emit('loginRegisterLogged')
                  } else {
                    if (this.$store.state.company.block_address_navigation !== "NO") {
                      console.log('COMPANY NEEDS BLOCK')
                      this.enterOrRegister = false
                      this.loginModal = false
                      this.registerModal = false
                      this.forgotModal = false
                      this.validationModal = false
                      this.changePassModal = false
                      this.$emit('loginRegisterLogged')
                    } else {
                      this.$router.push({path: '/home'})
                    }
                  }
                }
              }
            } else {
              // user has no templogin
              console.log('user has not temp login')
              this.loginModal = true
              this.validationModal = false
              this.enterOrRegister = false
            }
          } else {
            this.$store.state.showLoading = false
            //this.$router.push({path: '/changePass'})
            this.changePassModal = true
            this.validationToForgot = false
            this.validationModal = false
          }
          this.$store.state.showLoading = false
        } else {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    },

    async reSendValidationCode () {
      this.$store.state.showLoading = true
      let result = await UserConn.resendValidationCode()
      if (result.error) {
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        EventBus.$emit('showAlert', 'success', 'Um novo código foi enviado ao seu email/celular')
      }
      this.$store.state.showLoading = false
    },

    // CHANGE PASSWORD

    async resendCodeToForgot () {
      if (this.forgotEmail) {
        localStorage.setItem('tryValidationEmail', this.forgotEmail)
        let result = await UserConn.resendValidationCode()
        if (!result.error) {
          this.$store.state.tempId = result.userId
          this.validationModal = true
          this.validationToForgot = true
          this.forgotModal = false
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    },

    async changePass () {
      let code = this.$store.state.tempCode
      let userId = this.$store.state.tempId
      if (this.validateNewPasswordForm ()) {
        this.$store.state.showLoading = true
        let result = await UserConn.changePass(this.newPassword, code, userId)
        if (!result.error) {
          
          // on change pass auto login
          let result = await UserConn.doLogin(localStorage.getItem('tryValidationEmail'), this.newPassword)
          this.$store.state.showLoading = false
          this.closeAllModal()
          if (!result.error) {
            this.doLogin()
             this.$store.state.showLoading = false
          } else {
            this.loginModal = true
            EventBus.$emit('showAlert', 'error', 'Erro ao realizar auto login')
          }
        } else {
          EventBus.$emit('showAlert', 'error', 'Erro ao alterar senha')
        }
        this.$store.state.showLoading = false
      }
    },
    validateNewPasswordForm () {
      if (
        this.validatePassword() &&
        this.validatePassword2()
      ) {
        return true
      } else {
        return false
      }
    },
    validatePassword () {
      if ( this.newPassword && this.newPassword.length >= 6 ) {
        return true
      } else {
        EventBus.$emit('showAlert', 'error', 'As senhas precisam ter 6 digitos')
        return false
      }
    },
    validatePassword2 () {
      if ( this.newPasswordConfirm && this.newPasswordConfirm.length >= 6 ) {
        if ( this.newPasswordConfirm === this.newPassword) {
          return true
        } else {
          EventBus.$emit('showAlert', 'error', 'As senhas digitadas não são iguais')
          return false
        }
      } else {
        EventBus.$emit('showAlert', 'error', 'As senhas precisam ter 6 digitos')
        return false
      }
    },

    closeAllModal () {
      this.enterOrRegister = false
      this.loginModal = false
      this.registerModal = false
      this.forgotModal = false
      this.validationModal = false
      this.changePassModal = false
    }

  }
}
</script>

<style lang="scss">


</style>
